import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
let routeList = [{
  path: '/',
  name: 'index',
  redirect: '/index', // 设置默认指向的路径
  component: () =>
    import('../views/index.vue'),
  meta: {
    title: '主页'
  }
}, {
  path: '/index',
  name: 'index',
  component: () =>
    import('../views/index.vue'),
  meta: {
    title: 'Index'
  }
}, {
  path: '/error',
  name: 'error',
  component: () =>
    import('../views/404.vue'),
  meta: {
    title: '404'
  }
}]
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routeList
})
// 钩子
router.beforeEach((to, from, next) => {
  console.log('beforeEach', to, from)
  next();
});

export default router
